import React, { useState, useContext } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startLogin } from "../../actions/auth";
import { TfiEye } from "react-icons/tfi";

export const IniciarSesion = () => {
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useDispatch()
  const [form, setForm] = useState({
    email: "",
    password: ""
  })
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = form;

    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Ingrese su correo y contraseña",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          container: 'custom-body'
        }
      });
      return;
    }

    const result = await dispatch(startLogin(email, password));

    if (!result.ok) {
      Swal.fire({
        icon: "success",
        title: "Inicio de sesión exitoso",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          container: 'custom-body'
        }
      });
      navigate("/");
    } else {
      Swal.fire({
        icon: "error",
        title: "Error al iniciar sesión",
        text: result?.message || "Credenciales inválidas",
        timer: 2500,
        showConfirmButton: false,
        customClass: {
          container: 'custom-body'
        }
      });
    }
  }

  return (
    // <div className="login-container font-family-montserrat">
    //   <form className="login-form flex-container">
    //   <h2 className="font16 color-520FDA extrabold-800">
    //     INICIO DE SESIÓN
    //   </h2>
    //     <div className="form-grupo mrg-bottom19">
    //       <label htmlFor="email" className="txt-start">
    //         Correo electrónico
    //       </label>
    //       <input
    //         type="email"
    //         id="email"
    //         name="email"
    //         className="login-input"
    //         style={{ fontSize: '16px' }}
    //         value={form.email}
    //         onChange={handleChange}
    //       />
    //     </div>
    //     <div className="form-grupo">
    //       <label htmlFor="password" className="txt-start">
    //         Contraseña
    //       </label>
    //       <input
    //         type="password"
    //         id="password"
    //         name="password"
    //         className="login-input"
    //         style={{ fontSize: '16px' }}
    //         value={form.password}
    //         onChange={handleChange}
    //       />
    //     </div>
    //     <div className="form-footer flex-container align-center">
    //       <a href="#" className="forgot-password color-520FDA font11 txt-semibold" >
    //         Olvide mi contraseña
    //       </a>
    //       <button type="button" id="login-button" onClick={handleSubmit}>
    //         Iniciar sesión
    //       </button>
    //     </div>
    //     <div className="registro-link font9 color757575">
    //       ¿Nuevo cliente?{" "}
    //       <Link to="/registrarse" className="color757575">
    //         Crear una cuenta
    //       </Link>
    //     </div>
    //   </form>
    // </div>
    <div className="login-container font-family-montserrat">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>INICIO DE SESIÓN</h2>

        <label htmlFor="email">Correo electrónico</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          required
        />

        <div className="form-group-login password">
          <label htmlFor="password">Contraseña</label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              // className={`form-input ${error.password ? "input-error" : ""}`}
              value={form.password}
              onChange={handleChange}
              required
            />
            <span
              className="eyes-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              <TfiEye size={29} style={{ color: "C1C1C1" }} />
            </span>
          </div>
        </div>

        <div className="forgot-password">
          <a href="#">Olvidé mi contraseña</a>
        </div>

        <div className="login-button" onClick={handleSubmit}>
          Iniciar sesión
        </div>

        <p className="register-text">
          ¿Nuevo cliente? <Link to="/registrarse">Crear una cuenta</Link>
        </p>
      </form>
    </div>
  );
};
